import { SAVE_PRELEVEMENT } from './actionTypes'
import { PrelevementTypes } from './types'
import { PrelevementModalModel } from '../../../types/prelevement/prelevementModalModel'

export const savePrelevement = (prelevementData: PrelevementModalModel): PrelevementTypes => {
	return (
		{
			type: SAVE_PRELEVEMENT,
			payload: prelevementData
		}
	)
}
